"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUtilsConfig = void 0;
exports.ApiUtilsConfig = {
    apiKey: {
        name: 'apiKey',
        defaultValue: null,
    },
};
//# sourceMappingURL=ApiUtilsConfig.js.map